{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/transfer-and-allocate",
  "title": "Transfer and Allocate",
  "description": "Transfer and allocate create/edit form field catalog.",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "Transfer Allocate ID",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "maxLength": 100,
      "noBlank": true,
      "noDoubleSpace": true
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "adapterProps": { "rows": 4 }
    },
    "isDrs2BrokerTransferAllocate": {
      "type": "boolean",
      "title": "Is DRS Broker Transfer Allocate",
      "widget": "checkbox",
      "default": false
    }
  }
}
